<template>
  <v-dialog
    v-model="visible"
    @keydown.esc="close"
    persistent
    max-width="520"
    style="z-index: 6"
  >
    <v-form ref="certificateForm" @submit.prevent="submit">
      <v-card class="cert-dialog-card">
        <!-- Header with gradient -->
        <div class="cert-dialog-header">
          <div class="d-flex align-center justify-space-between">
            <h2 class="cert-dialog-title">Dodaj certifikat</h2>
            <v-btn icon small @click="close" class="close-btn">
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <v-card-text class="pt-6 pb-4 px-6">
          <!-- Company Name -->
          <div class="mb-5">
            <div class="company-label">Firma</div>
            <div class="company-name">{{ company.name }}</div>
          </div>

          <!-- File Input -->
          <v-file-input
            autofocus
            label="Učitaj certifikat *"
            accept=".p12, .pfx, .pem, .crt, .cer, .ca-bundle, .p7b, .p7c, .p7s"
            :rules="[rules.req, rules.certSize]"
            @change="certFileChange"
            outlined
            dense
            prepend-icon=""
            prepend-inner-icon="mdi-file-certificate"
            class="cert-input mb-4"
          >
          </v-file-input>

          <!-- Password Input -->
          <v-text-field
            label="Lozinka certifikata *"
            v-model="certPass"
            ref="certPass"
            outlined
            dense
            :rules="[rules.req]"
            :type="passVisible ? 'text' : 'password'"
            :append-icon="passVisible ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="() => (passVisible = !passVisible)"
            class="cert-input"
          ></v-text-field>
        </v-card-text>

        <v-card-actions class="px-6 pb-5 pt-2">
          <v-spacer></v-spacer>
          <v-btn
            class="cert-cancel-btn"
            @click="close"
            :disabled="submitting"
            text
            elevation="0">
            Odustani
          </v-btn>
          <v-btn
            class="cert-save-btn"
            :loading="submitting"
            :disabled="submitting"
            type="submit"
            elevation="0">
            <v-icon left small>mdi-upload</v-icon>
            Dodaj certifikat
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import rules from '@/plugins/rules'

import { df, auth } from '@/plugins/firebase'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'CertificateUpload',
  inject: ['showMsgBox', 'showLoader', 'hideLoader', 'showAlert'],
  data: () => ({
    visible: false,
    certificate: undefined,
    certPass: undefined,
    business: undefined,
    company: {},
    passVisible: false,
    submitting: false,
    unsubscribe: undefined,
    unsubscribeError: undefined,
    listeners: [],
    rules: {
      req: rules.req(),
      certSize: (value) =>
        !value ||
        value.size < 1048487 ||
        'Najveća dozvoljena veličina dokumenta je 1MB.'
    }
  }),
  methods: {
    open (company) {
      this.company = Object.assign(this.company, company)
      this.visible = true
    },
    close () {
      this.$refs.certificateForm.reset()
      this.submitting = false
      this.visible = false
      this.unsubscribeListeners()
    },
    resetForm () {
      this.$refs.certificateForm.reset()
    },
    toBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })
    },
    async certFileChange (_file) {
      if (_file) {
        const file = await this.toBase64(_file)
        try {
          this.certificate = file.split(',')[1]
        } catch (err) {
          this.certificate = undefined
          this.showMsgBox({
            text: err,
            actions: ['cancel'],
            cancelBtnText: 'OK',
            color: 'error'
          })
        }
      }
    },
    unsubscribeListeners () {
      this.listeners.forEach((listener) => {
        listener()
        this.listeners = this.listeners.filter((l) => l !== listener)
      })
    },
    submit () {
      if (!this.$refs.certificateForm.validate()) return
      const reqId = uuidv4()
      const payload = {
        action: {
          operation: 'set',
          entity: 'certificate',
          params: {
            cert: this.certificate,
            // hash: `web.${this.certPass}.${auth.currentUser.uid}`,
            company_id: this.company.id,
            password: this.certPass
          }
        }
      }

      this.submitting = true
      df.doc(`request/${reqId}`)
        .set({
          msg_id: reqId,
          user_id: `${auth.currentUser.uid}`,
          device_id: 'web',
          created: `${new Date().getTime()}`,
          type: 'certificate',
          payload: btoa(unescape(encodeURIComponent(JSON.stringify(payload))))
        })
        // .then(function (doc) {
        // })
        // .catch(function (error) {
        // })
        .finally(() => {})

      const docRef = df.doc(`response/${reqId}`)
      this.listeners.push(
        docRef.onSnapshot((doc) => {
          if (doc && doc.data() && doc.data().header && doc.data().header.code === 200) {
            this.submitting = false
            this.showMsgBox({
              text: 'Certifikat je uploadan!',
              actions: ['cancel'],
              cancelBtnText: 'OK'
            })
            this.$emit('uploaded')
            this.close()
          }
        })
      )

      const errorRef = df.collection('errors')
      this.listeners.push(
        errorRef
          .where('error_id', '==', `${auth.currentUser.uid}.${reqId}`)
          .onSnapshot((documentSnapshots) => {
            if (documentSnapshots.docs && !documentSnapshots.docs.empty) {
              documentSnapshots.docs.forEach((item) => {
                const error = item.data()
                if (error && error.error_status) {
                  let erStatus = ''
                  if (error.error_status.includes('Invalid certificate password:')) {
                    erStatus = 'Neispravna lozinka certifikata'
                    this.$refs.certPass.reset()
                  }
                  this.showMsgBox({
                    text: erStatus || error.error_status,
                    actions: ['cancel'],
                    cancelBtnText: 'OK',
                    color: 'error'
                  })
                  this.submitting = false
                }
              })
            }
          })
      )
    }
  },
  beforeDestroy () {
    this.unsubscribeListeners()
  }
}
</script>
<style scoped>
/* Certificate Dialog Styles */
.cert-dialog-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.1) !important;
  overflow: hidden;
}

.cert-dialog-header {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.5) 0%,
    rgba(57, 137, 201, 0.45) 50%,
    rgba(97, 84, 164, 0.5) 100%) !important;
  padding: 20px 24px;
  position: relative;
}

.cert-dialog-title {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: white !important;
  letter-spacing: 0.5px !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin: 0;
}

.close-btn {
  background: rgba(255, 255, 255, 0.2) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.3) !important;
  transform: rotate(90deg);
}

.company-label {
  font-size: 12px !important;
  font-weight: 600 !important;
  color: rgba(57, 137, 201, 0.8) !important;
  text-transform: uppercase;
  letter-spacing: 0.5px !important;
  margin-bottom: 8px;
}

.company-name {
  font-size: 16px !important;
  font-weight: 600 !important;
  color: rgba(70, 70, 80, 0.9) !important;
  letter-spacing: 0.3px !important;
  padding: 12px 16px;
  background: rgba(0, 179, 190, 0.08) !important;
  border-radius: 12px;
  border: 1px solid rgba(0, 179, 190, 0.15);
}

.cert-input {
  background: rgba(255, 255, 255, 0.8) !important;
  border-radius: 12px !important;
}

.cert-input >>> .v-input__control {
  background: rgba(255, 255, 255, 0.8) !important;
  border-radius: 12px !important;
}

.cert-input >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.8) !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(0, 179, 190, 0.08) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.cert-input >>> .v-input__slot:hover {
  border-color: rgba(0, 179, 190, 0.4) !important;
  box-shadow: 0 4px 12px rgba(0, 179, 190, 0.15) !important;
}

.cert-input >>> .v-text-field__slot input,
.cert-input >>> .v-file-input__text {
  color: rgba(70, 70, 80, 0.9) !important;
  font-weight: 500 !important;
}

.cert-input >>> .v-label {
  color: rgba(57, 137, 201, 0.7) !important;
  font-weight: 500 !important;
}

.cert-input >>> .v-icon {
  color: rgba(57, 137, 201, 0.7) !important;
}

.cert-cancel-btn {
  background: transparent !important;
  color: rgba(70, 70, 80, 0.7) !important;
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 10px 24px !important;
  height: 44px !important;
  box-shadow: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.cert-cancel-btn:hover {
  background: rgba(70, 70, 80, 0.08) !important;
  color: rgba(70, 70, 80, 0.9) !important;
}

.cert-save-btn {
  background: rgba(255, 255, 255, 0.9) !important;
  color: #3989C9 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(57, 137, 201, 0.25) !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 10px 24px !important;
  height: 44px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.cert-save-btn:hover {
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.25) !important;
  border-color: rgba(57, 137, 201, 0.4) !important;
  transform: translateY(-1px);
  background: rgba(255, 255, 255, 1) !important;
}

.cert-save-btn .v-icon {
  font-size: 18px !important;
  margin-right: 8px !important;
}
</style>
